// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2kOfJ","label":"Section_label__mCVll","contentWrap":"Section_contentWrap__3EOc8","footer":"Section_footer__2rAqw","footerInner":"Section_footerInner__3Jh2r"};